import { createTheme } from "@mui/material/styles";

const getCssVariable = (variableName) => {
    const cssVariableName = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
    return cssVariableName;
}

export const theme = createTheme({
    palette: {
        primary: {
            main: '#26890D'
        }
    },
    typography: {
        fontFamily: getCssVariable('db-font-primary')
    },
    components: {
        MuiModal: {
            styleOverrides: {

            }
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    backgroundColor: '#26890D',
                    fontSize: '20px',
                    width: '600px',
                    justifyContent: 'center'
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    color: 'rgb(33, 37, 41)',
                    // '& .MuiFormLabel-root': {
                    //     color: 'rgb(33, 37, 41)'
                    // }
                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    padding: '2px 9px',
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '0px',
                    textTransform: 'none',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '20px',
                    "&.MuiButton-contained.btn-secondary": {
                        backgroundColor: "#FFF",
                        color: "#000",
                        borderRadius: "8px",
                        border: "1px solid #000",
                        "&:hover": {
                            backgroundColor: "#BBBCBC",
                        },
                        "&:active": {
                            backgroundColor: "#EBEBEB",

                        },
                        "&:focus": {
                            backgroundColor: "#EBEBEB",
                        },
                        "&:disabled": {
                            backgroundColor: "#FFF",
                            color: "#97999B !important",
                            boxShadow: "none",
                            border: "1px solid #97999B",
                        },
                    },
                    "&.MuiButton-contained.btn-primary": {
                        backgroundColor: "#26890D",
                        color: "#FFFFFF",
                        borderRadius: "8px",
                        "&:hover": {
                            backgroundColor: "#20730B",
                        },
                        "&:active": {
                            backgroundColor: "#1D680A ",
                            boxShadow: "inset 0px 2px 4px rgba(0, 0, 0, 0.3)",
                        },
                        "&:disabled": {
                            backgroundColor: "#A2CA98",
                            color: "#FFFFFF !important",
                            boxShadow: "none",
                        },
                    },
                    "&.MuiButton-outlined": {
                        backgroundColor: "#FFF",
                        color: "#000000",
                        borderRadius: "8px",
                        border: "none",
                        "&:hover": {
                            backgroundColor: "#BBBCBC",
                        },
                        "&:active": {
                            backgroundColor: "#EBEBEB",
                        },
                        "&:disabled": {
                            backgroundColor: "#A0DCFF99",
                            color: "#97999B !important",
                            boxShadow: "none",
                        },
                    },
                }
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiChip-root': {
                        borderRadius: '8px',
                        backgroundColor: '#A0DCFF99',
                        color: '#000000',
                    },
                    '& .css-1vcbgpn-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon': {
                        color: '#000000',
                    },
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#000000',
                        borderWidth: '1px',
                    },
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    // Specific targeting for MenuItems inside Select dropdowns
                    '.MuiPopover-root .MuiMenu-paper &': {
                        '&.Mui-selected': {
                            backgroundColor: '#EBEBEB !important',
                            color: '#000000 !important',
                            '&:hover': {
                                backgroundColor: '#BBBCBC !important',
                            },
                        },
                        '&[aria-selected="true"]': {
                            backgroundColor: '#EBEBEB !important',
                            '&:hover': {
                                backgroundColor: '#BBBCBC !important',
                            },
                        },
                        '&:hover': {
                            backgroundColor: '#BBBCBC',
                        },
                        fontSize: '12px',
                        fontWeight: '400',
                        lineHeight: '16px',
                    }
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    '&.MuiMenu-paper': {
                        borderRadius: '8px',
                        border: '1px solid #000000',
                        marginTop: '4px',
                    },
                },
            },
        },
    }
});